import React, { createContext, useContext, useEffect, useState } from "react";

/// Admin panel dili. Anahtarlar Türkçe metnin kendisidir; karşılığı yoksa
/// Türkçe gösterilir, böylece çevrilmemiş sayfalar bozulmaz.
const EN = {
  // kabuk
  Yönetim: "Admin",
  Sahip: "Owner",
  "Bildirim gönder": "Send notification",
  Çıkış: "Log out",
  // panel
  Panel: "Dashboard",
  "AYVO · canlı yayın ve coin ekonomisi özeti": "AYVO · live stream and coin economy overview",
  Bugün: "Today",
  Dün: "Yesterday",
  "Şu an": "Right now",
  "Canlı durum": "Live status",
  "Bekleyen işler": "Needs attention",
  "Bugün en çok kazananlar": "Top earners today",
  "Bugün en çok harcayanlar": "Top spenders today",
  "Son satın almalar": "Recent purchases",
  "Hediye hacmi": "Gift volume",
  "Coin geliri": "Coin revenue",
  "Yeni kullanıcı": "New users",
  "Satın alma": "Purchases",
  "Çevrimiçi kullanıcı": "Users online",
  "Çevrimiçi yayıncı": "Hosts online",
  "Şu an yayında": "Live now",
  "Açık oda": "Open rooms",
  "Odalardaki kişi": "People in rooms",
  "Süren PK": "Live PK",
  "Son 1 saat": "Last hour",
  "Yayıncı başvurusu": "Host applications",
  "Çekim talebi": "Withdrawal requests",
  "Açık şikayet": "Open complaints",
  "Kayıt yok.": "No records.",
  "Yükleniyor…": "Loading…",
  hediye: "gifts",
  coin: "coins",
  kişi: "people",
  Dil: "Language",
  // menü grupları
  Genel: "General",
  Canlı: "Live",
  Güvenlik: "Safety",
  Gelir: "Revenue",
  Ekip: "Team",
  Ayarlar: "Settings",
  // menü
  Kullanıcılar: "Users",
  Yayıncılar: "Hosts",
  Ajanslar: "Agencies",
  "Seviye Yönetimi": "Levels",
  "Canlı yayınlar": "Live streams",
  "Sesli odalar": "Voice rooms",
  "PK düelloları": "PK battles",
  Oyunlar: "Games",
  Anlar: "Moments",
  "Mesaj merkezi": "Messages",
  "Şikayet kuyruğu": "Complaint queue",
  "Eski şikayetler": "Old complaints",
  Engellenenler: "Blocked",
  "Yasaklı kelimeler": "Banned words",
  "Güvenlik listeleri": "Safety lists",
  "Cihaz / IP yasağı": "Device / IP ban",
  "Ekonomi & VIP": "Economy & VIP",
  Hediyeler: "Gifts",
  "Mağaza & Yüzükler": "Store & Rings",
  "Aile & Evlilik": "Family & Marriage",
  "Coin paketleri": "Coin packs",
  "Yetkili Bayi": "Dealer",
  "Maaş Politikası": "Salary policy",
  "Web Sitesi": "Website",
  "PK Turnuvası": "PK tournament",
  "Para akışı": "Money flow",
  "Çekim talepleri": "Withdrawals",
  "Paket gönder": "Send package",
  "Personel & Paketler": "Staff & packages",
  "İşlem günlüğü": "Activity log",
  Afiş: "Banner",
  Çıkartma: "Sticker",
  BD: "BD",
  Koruma: "Guardian",
  "Fan Kulübü": "Fan Club",
  "Aylık Kart": "Monthly Card",
  "Görev Merkezi": "Task Center",
  "Davet Kodu": "Invite Code",
  "Sohbet Çevirisi": "Chat Translation",
  "Uygulama ayarları": "App settings",
  Profilim: "My profile",
};

const AR = {
  Yönetim: "الإدارة",
  Sahip: "المالك",
  "Bildirim gönder": "إرسال إشعار",
  Çıkış: "تسجيل الخروج",
  Panel: "لوحة التحكم",
  "AYVO · canlı yayın ve coin ekonomisi özeti": "AYVO · ملخص البث المباشر واقتصاد العملات",
  Bugün: "اليوم",
  Dün: "أمس",
  "Şu an": "الآن",
  "Canlı durum": "الحالة المباشرة",
  "Bekleyen işler": "بانتظار الإجراء",
  "Bugün en çok kazananlar": "الأكثر ربحاً اليوم",
  "Bugün en çok harcayanlar": "الأكثر إنفاقاً اليوم",
  "Son satın almalar": "آخر المشتريات",
  "Hediye hacmi": "حجم الهدايا",
  "Coin geliri": "إيرادات العملات",
  "Yeni kullanıcı": "مستخدمون جدد",
  "Satın alma": "المشتريات",
  "Çevrimiçi kullanıcı": "مستخدمون متصلون",
  "Çevrimiçi yayıncı": "مذيعون متصلون",
  "Şu an yayında": "على الهواء الآن",
  "Açık oda": "الغرف المفتوحة",
  "Odalardaki kişi": "الأشخاص في الغرف",
  "Süren PK": "معارك جارية",
  "Son 1 saat": "آخر ساعة",
  "Yayıncı başvurusu": "طلبات المذيعين",
  "Çekim talebi": "طلبات السحب",
  "Açık şikayet": "شكاوى مفتوحة",
  "Kayıt yok.": "لا توجد سجلات.",
  "Yükleniyor…": "جارٍ التحميل…",
  hediye: "هدية",
  coin: "عملة",
  kişi: "شخص",
  Dil: "اللغة",
  Genel: "عام",
  Canlı: "مباشر",
  Güvenlik: "الأمان",
  Gelir: "الإيرادات",
  Ekip: "الفريق",
  Ayarlar: "الإعدادات",
  Kullanıcılar: "المستخدمون",
  Yayıncılar: "المذيعون",
  Ajanslar: "الوكالات",
  "Seviye Yönetimi": "إدارة المستويات",
  "Canlı yayınlar": "البث المباشر",
  "Sesli odalar": "الغرف الصوتية",
  "PK düelloları": "معارك PK",
  Oyunlar: "الألعاب",
  Anlar: "اللحظات",
  "Mesaj merkezi": "مركز الرسائل",
  "Şikayet kuyruğu": "قائمة الشكاوى",
  "Eski şikayetler": "الشكاوى القديمة",
  Engellenenler: "المحظورون",
  "Yasaklı kelimeler": "الكلمات المحظورة",
  "Güvenlik listeleri": "قوائم الأمان",
  "Cihaz / IP yasağı": "حظر الجهاز / IP",
  "Ekonomi & VIP": "الاقتصاد و VIP",
  Hediyeler: "الهدايا",
  "Mağaza & Yüzükler": "المتجر والخواتم",
  "Aile & Evlilik": "العائلة والزواج",
  "Coin paketleri": "باقات العملات",
  "Yetkili Bayi": "الوكيل المعتمد",
  "Maaş Politikası": "سياسة الرواتب",
  "Web Sitesi": "الموقع",
  "PK Turnuvası": "بطولة PK",
  "Para akışı": "تدفق الأموال",
  "Çekim talepleri": "طلبات السحب",
  "Paket gönder": "إرسال باقة",
  "Personel & Paketler": "الموظفون والباقات",
  "İşlem günlüğü": "سجل العمليات",
  Afiş: "اللافتة",
  Çıkartma: "الملصقات",
  BD: "BD",
  Koruma: "الحماية",
  "Fan Kulübü": "نادي المعجبين",
  "Aylık Kart": "البطاقة الشهرية",
  "Görev Merkezi": "مركز المهام",
  "Davet Kodu": "رمز الدعوة",
  "Sohbet Çevirisi": "ترجمة الدردشة",
  "Uygulama ayarları": "إعدادات التطبيق",
  Profilim: "ملفي",
};

const DICTS = { tr: null, en: EN, ar: AR };
export const LANGS = [
  { code: "tr", label: "Türkçe", flag: "🇹🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
];

const Ctx = createContext({ lang: "tr", setLang: () => {}, t: (k) => k });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("adminLang") || "tr");

  useEffect(() => {
    document.documentElement.lang = lang;
    // Arapça sağdan sola
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const setLang = (v) => {
    localStorage.setItem("adminLang", v);
    setLangState(v);
  };

  const t = (key) => {
    if (key == null) return key;
    const d = DICTS[lang];
    if (!d) return key;
    return d[key] ?? key;
  };

  return <Ctx.Provider value={{ lang, setLang, t }}>{children}</Ctx.Provider>;
};

export const useI18n = () => useContext(Ctx);
